// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H14V9.0202L22 10.6869V22H16V16H14V22H2V2ZM8 7.7702L12 8.60353V4H4V20H8V7.7702Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-15-filled')
export default class City15FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-15-filled',
    }
  }
}
